import styled from "styled-components";
import { COLOR_PRIMARY } from "../../helpers/theme";

export const DataTableWrapper = styled.div`
  margin-top: 20px;
  border-radius: 5px;
  border: 1px solid #e2e2e2;

  & > .tablewrapper--title {
    font-size: 14px;
    font-weight: 600;
    color: #161616;
    background-color: #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding: 10px 20px 10px 20px;
    border-bottom: 1px solid #e2e2e2;
  }

  .tablewrapper--loading {
    text-align: center;

    & > .tablewrapper--loading--caption {
      display: flex;
      align-items: center;
      justify-content: center;

      & > span {
        margin-left: 5px;
      }
    }
  }

  & > .tablewrapper--pagination {
    display: flex;
    padding-top: 5px;
    padding-bottom: 5px;
    align-items: center;
    justify-content: center;
    & > * {
      min-width: 30px;
      padding: 5px;
      color: #fff;
      cursor: pointer;
      font-size: 14px;
      margin-right: 3px;
      text-align: center;
      border-radius: 5px;
      transition: 0.15s all;
      border: 1px solid transparent;
      background-color: ${COLOR_PRIMARY};

      &:last-child {
        margin-right: 0px;
      }

      &.active,
      &:hover {
        color: ${COLOR_PRIMARY};
        background-color: #fff;
        border-color: ${COLOR_PRIMARY};
      }
    }
  }

  & .tablewrapper--action {
    display: flex;

    & > * {
      margin-right: 5px;
      &::last-child {
        margin-right: 0;
      }
    }
  }

  & > .tablewrapper--table {
    width: 100%;

    & > table {
      border-spacing: 0;
      min-width: 100%;
      text-align: left;
      border-collapse: collapse;

      & > thead {
        background: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border-bottom: 1px solid var(--color-border);
      }

      & > thead.field-filter {
        & tr > th > * {
          width: 100%;
          padding: 5px 10px 5px 10px;
          border: 1px solid var(--color-border);
          border-radius: var(--corner-radius-small);
          -webkit-appearance: none;
        }
      }

      & > thead > tr > th {
        padding: var(--table-tr-space);
        font-size: 14px;
        cursor: pointer;
      }

      & > tbody > tr {
        padding-bottom: 5px;
        border-bottom: 1px solid var(--color-border);
      }

      & > tbody > tr:last-child {
        border-bottom: 1px solid transparent !important;
      }

      & > tbody > tr > td {
        background: #fff;
        font-size: 14px;
        padding: var(--table-tr-space);

        & .broken {
          font-weight: 800;
          color: red;
        }
      }

      & > tbody > tr:last-child td:first-child {
        border-bottom-left-radius: var(--corner-radius-small);
      }

      & > tbody > tr:last-child td:last-child {
        border-bottom-right-radius: var(--corner-radius-small);
      }

      .sortArrow {
        width: 8px;
        margin-left: 5px;
      }
    }
  }
`;
